import LazyLoad from 'vanilla-lazyload';

// Exporting an instance means every import of this file gets the same instance of lazyload
export default new LazyLoad({elements_selector: 'img[data-src]'});